var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenNewIcon = function SvgOpenNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h18v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0057B8",
    fillRule: "evenodd",
    d: "M13.5 7.313h1.125v7.312c0 .932-.755 1.688-1.687 1.688H3.374a1.687 1.687 0 0 1-1.687-1.688V5.063c0-.932.755-1.688 1.687-1.688h7.313V4.5H3.375a.563.563 0 0 0-.562.563v9.562c0 .31.251.563.562.563h9.563c.31 0 .562-.252.562-.563zm-1.687-5.625v1.125h2.581L9.563 7.65l.787.787 4.838-4.831v2.582h1.124v-4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgOpenNewIcon;